<ng-container [formGroup]="fg">
  <mat-form-field class="full-width">
    <textarea
      matInput
      [maxlength]="maxlength"
      placeholder="{{ placeholder | translate }}"
      [formControl]="control"
      matTextareaAutosize
      [cdkTextareaAutosize]="true"
      [cdkAutosizeMaxRows]="matAutosizeMaxRows"
      [cdkAutosizeMinRows]="matAutosizeMinRows"
    ></textarea>
    <mat-hint align="start">{{hint | translate}}</mat-hint>
    <mat-hint align="end">
      {{ control.value?.length }} / {{ maxlength }}</mat-hint
    >
    <mat-error *ngIf="control.hasError" class="error-message">
      <ng-container *ngIf="control.errors?.message">
        {{ control.errors.message }}
      </ng-container>
      <ng-container *ngIf="control.errors?.required">
        {{ isRequiredMessage }}
      </ng-container>
      <ng-container *ngIf="control.errors?.maxlength">
        {{ isMaxLengthMessage }}
      </ng-container>
    </mat-error>
  </mat-form-field>
</ng-container>
